<swiper-container
  [loop]="imageList.length > 1"
  pagination="true"
  autoPlay="true"
  slides-per-view="1"
  slides-per-group="1"
>
  @for (image of imageList; track image) {
    <swiper-slide class="slide-item">
      <div [style.background-image]="'url(https://cardapioac.mane.com.vc'+image.path.url+ ')'" (click)="onGoToRestaurant(image.cardapioId)"></div>
    </swiper-slide>
  }
</swiper-container>